import { FiBook, FiVideo, FiUsers } from "react-icons/fi";
import './additionalresources.css';

const resources = [
  { title: "Documentation", icon: <FiBook /> },
  { title: "Video Tutorials", icon: <FiVideo /> },
  { title: "Community", icon: <FiUsers /> },
];

const AdditionalResources = () => {
  return (
    <>
      <h3 className="rf-addres-title">Additional Resources</h3>
      <div className="rf-addres-grid">
        {resources.map((res, i) => (
          <div className="rf-addres-card" key={i}>
            <div className="rf-addres-icon">{res.icon}</div>
            <span className="rf-addres-text">{res.title}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default AdditionalResources;
